import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = ({ f }) => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#172033] text-[#F6F5F1]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif-display text-3xl md:text-4xl">
              Whitlock<span className="text-[#B0863A]">16</span>
            </div>
            <p className="mt-5 text-[#F6F5F1]/50 text-xs leading-relaxed max-w-sm">
              {f.disclaimer}
            </p>
          </div>

          <div className="md:col-span-4 md:col-start-8 space-y-4 text-sm text-[#F6F5F1]/80">
            <a
              href="https://maps.google.com/?q=16+Boulevard+Brand+Whitlock+Bruxelles"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address"
              className="flex items-start gap-3 link-underline w-fit"
            >
              <MapPin size={16} strokeWidth={1.5} className="mt-0.5 text-[#B0863A] shrink-0" />
              <span>{f.address}</span>
            </a>
            <a
              href={`mailto:${f.email}`}
              data-testid="footer-email"
              className="flex items-center gap-3 link-underline w-fit"
            >
              <Mail size={16} strokeWidth={1.5} className="text-[#B0863A] shrink-0" />
              <span>{f.email}</span>
            </a>
            <a
              href={`tel:${f.phone.replace(/[\s()]/g, "")}`}
              data-testid="footer-phone"
              className="flex items-center gap-3 link-underline w-fit"
            >
              <Phone size={16} strokeWidth={1.5} className="text-[#B0863A] shrink-0" />
              <span>{f.phone}</span>
            </a>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#F6F5F1]/12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[#F6F5F1]/45 text-xs">
          <span>© {new Date().getFullYear()} · {f.rights}</span>
          <span className="font-hand text-base text-[#D9B87A]">Bruxelles</span>
        </div>
      </div>
    </footer>
  );
};
